import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import MediaCustomizations from './media-customizations-model'
import {
  MediaCustomizationsMetaProperties,
  MediaCustomizationsProperties,
} from './mediaCustomizations-property-definitions'

export async function load_mediaCustomizationss($args: {
  uid: string
}): Promise<MediaCustomizations[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(
    db,
    `mediaCustomizationss`,
    `${uid}`,
    'mediaCustomizations',
  )
  let result: MediaCustomizations[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertTomediaCustomizations(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertTomediaCustomizations(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_mediaCustomizations(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(
      db,
      `mediaCustomizationss`,
      `${args.uid}`,
      'mediaCustomizations',
      args.id,
    )
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_mediaCustomizations(
  args: MediaCustomizations,
): Promise<MediaCustomizations> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let mediaCustomizations_collection = firestore.doc(
      db,
      `mediaCustomizationss`,
      `${owner}`,
      'mediaCustomizations',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(MediaCustomizationsProperties),
      ...Object.values(MediaCustomizationsMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(mediaCustomizations_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(
      db,
      `mediaCustomizationss`,
      `${owner}`,
      'mediaCustomizations',
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(MediaCustomizationsProperties),
      ...Object.values(MediaCustomizationsMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
